<template>
    <b-alert variant="warning" class="mt-4" show>
        <h5 class="alert-heading">{{$t('label.unitSelected')}}</h5>
        <hr/>
        <div><strong>{{$t("label.fiche.buildingName")}}</strong> : {{selectedUnit.name}}</div>
        <div><strong>{{$tc('label.unitlabel', 1)}}</strong> : {{selectedUnit.unit}}</div>
        <div><strong>{{$t('label.fiche.rooms')}}</strong> : {{selectedUnit.specs.NBPIECE}}</div>
        <div><strong>{{$t('label.price')}}</strong> : {{selectedUnit.specs.publicUnitPrice}} $</div>
        <div v-if="selectedUnit.specs.DATEENT"><strong>{{$t('label.rentalDate')}}</strong> : {{selectedUnit.specs.DATEENT}} 
        <span v-if="selectedUnit.specs.DATEEND"> {{$t("label.fiche.to")}} {{selectedUnit.specs.DATEEND}}</span></div>
      </b-alert>
</template>

<script>
export default {
mixins: [],
props: ['selectedUnit'],
data() { return {}},
computed: {},
methods:{},
components: {}
}
</script>